import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=6cea4b3c&scoped=true&"
import script from "./DashboardPage.vue?vue&type=script&lang=js&"
export * from "./DashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=6cea4b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cea4b3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cea4b3c')) {
      api.createRecord('6cea4b3c', component.options)
    } else {
      api.reload('6cea4b3c', component.options)
    }
    module.hot.accept("./DashboardPage.vue?vue&type=template&id=6cea4b3c&scoped=true&", function () {
      api.rerender('6cea4b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/DashboardPage.vue"
export default component.exports